import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrlWithPathVariable, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return {
    id: data?.id,
    name: data?.name,
    type: data?.type,
    status: data?.status,
    supportNetBanking: data?.supportNetBanking,
    supportCard: data?.supportCard,
    contacts: data?.contactPDetails,
    publicIps: data?.publicIp,
    endpointInfo: {
      domain: data?.endpointDomain,
      status: data?.endpointStatus,
      checksumEncryptionSelect: data?.checksumEncryptionSelect,
      encryptionType: data?.encryptionType,
      redirectUrl: data?.entityRedirectURL,
      enrollUrl: data?.entityEnrollURL,
      authUrl: data?.entityAuthURL,
      stqUrl: data?.entityStqURL,
      s2sUrl: data?.entityS2SURL,
      rpslS2sUrl: data?.rpslS2SURL,
    },
    updatedBy: data?.updatedBy,
    createdDate: '' + data?.createdDate,
    updatedDate: '' + data?.updatedDate,
  }
}

const getEntityById = (id: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrlWithPathVariable(APIEndPoints.entityMasterGetById, id),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getEntityById }
